var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTestTypeOther(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2645_37139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
    fill: "#2B4B8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.875 9.5L7.625 9.51188C7.28 9.51188 7 9.23188 7 8.88688C7 8.54188 7.28 8.26188 7.625 8.26188L13.875 8.25V9.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.375 12.625H10.125V11.375H16.375C16.72 11.375 17 11.655 17 12C17 12.345 16.72 12.625 16.375 12.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.375 9.51188L15.125 9.5V8.25L16.375 8.26188C16.72 8.26188 17 8.54188 17 8.88688C17 9.2325 16.72 9.51188 16.375 9.51188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.875 15.75H7.625C7.28 15.75 7 15.47 7 15.125C7 14.78 7.28 14.5 7.625 14.5H13.875V15.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.375 15.75H15.125V14.5H16.375C16.72 14.5 17 14.78 17 15.125C17 15.47 16.72 15.75 16.375 15.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.875 12.625H7.625C7.28 12.625 7 12.345 7 12C7 11.655 7.28 11.375 7.625 11.375H8.875V12.625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2645_37139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTestTypeOther);
export default __webpack_public_path__ + "static/media/icon-test-type-other.f5865107bd0db92d19ee36ceb6358030.svg";
export { ForwardRef as ReactComponent };